import React, { useState } from "react";
import { BookOpen, TrendingDown, Scale, Info } from "lucide-react";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { fmtEur } from "../lib/api";
import { SOGLIA_AMM, COEFF_AMMORTAMENTO, DEDUC_PARZIALE } from "../config/fiscale";

export const LeggendaFiscale = ({ label = "Guida deducibilità", variant = "outline", size = "sm" }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button variant={variant} size={size} onClick={() => setOpen(true)} data-testid="leggenda-fiscale-btn">
        <BookOpen size={15} className="mr-1.5" /> {label}
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="leggenda-fiscale-dialog">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2"><Scale size={18} className="text-violet-700" /> Leggenda di deducibilità</DialogTitle>
          </DialogHeader>

          <div className="space-y-5 text-sm">
            {/* Soglia 516,46 */}
            <div className="rounded-lg border border-violet-200 bg-violet-50/60 p-4" data-testid="leggenda-soglia">
              <div className="flex items-center gap-2 font-head font-bold text-violet-800"><Info size={16} /> Soglia {fmtEur(SOGLIA_AMM)}</div>
              <p className="mt-1.5 text-muted-foreground">
                I beni con <b>costo unitario fino a {fmtEur(SOGLIA_AMM)}</b> possono essere <b>dedotti interamente nell'anno</b> (nessun ammortamento).
                <br />Oltre {fmtEur(SOGLIA_AMM)} il bene va <b>capitalizzato e ammortizzato</b> negli anni con il coefficiente della sua categoria.
              </p>
            </div>

            {/* Coefficienti ammortamento */}
            <div>
              <div className="flex items-center gap-2 font-head font-bold mb-2"><TrendingDown size={16} className="text-amber-600" /> Coefficienti di ammortamento (indicativi)</div>
              <div className="rounded-lg border overflow-hidden">
                <table className="w-full text-sm">
                  <thead><tr className="text-left text-[11px] uppercase tracking-wide text-muted-foreground bg-secondary/40 border-b"><th className="py-2 px-3">Categoria bene</th><th className="py-2 px-3 text-right">Aliquota annua</th><th className="py-2 px-3 text-right">Durata ~</th></tr></thead>
                  <tbody>
                    {COEFF_AMMORTAMENTO.map((c) => (
                      <tr key={c.cat} className="border-b last:border-0" data-testid={`leggenda-coeff-${c.perc}`}>
                        <td className="py-2 px-3">{c.cat}</td>
                        <td className="py-2 px-3 text-right tabnum font-semibold text-amber-700">{c.perc}%</td>
                        <td className="py-2 px-3 text-right tabnum text-muted-foreground">{Math.round(100 / c.perc)} anni</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Deducibilità parziali */}
            <div>
              <div className="flex items-center gap-2 font-head font-bold mb-2"><Scale size={16} className="text-violet-700" /> Deducibilità parziali ricorrenti</div>
              <div className="rounded-lg border overflow-hidden">
                <table className="w-full text-sm">
                  <thead><tr className="text-left text-[11px] uppercase tracking-wide text-muted-foreground bg-secondary/40 border-b"><th className="py-2 px-3">Tipo di spesa</th><th className="py-2 px-3 text-right">% deducibile</th></tr></thead>
                  <tbody>
                    {DEDUC_PARZIALE.map((c) => (
                      <tr key={c.cat} className="border-b last:border-0" data-testid={`leggenda-deduc-${c.perc}`}>
                        <td className="py-2 px-3">{c.cat}</td>
                        <td className="py-2 px-3 text-right tabnum font-semibold text-violet-700">{c.perc}%</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <p className="text-xs text-muted-foreground italic border-t pt-3">
              Valori standard indicativi a scopo gestionale: le aliquote e le deducibilità effettive vanno sempre confermate con il commercialista.
            </p>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
